import { render, staticRenderFns } from "./ClusterCardSmall.pug?vue&type=template&id=6df3a077&lang=pug&external"
import script from "./ClusterCardSmall.js?vue&type=script&lang=js&external"
export * from "./ClusterCardSmall.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports